import React, { useState } from 'react';
import { toast } from 'react-toastify';
import PrimaryBtn from '../../GlobalComponents/primaryBtn';
import SimpleInput from '../../SimpleInput';
import { validateEmail, validatePassword } from '../../../helpers/helperFunctions';
import httpRequest from '../../../helpers/httpRequest';
import { errMsg } from '../../../lib/constans';

const UserAccountDetails: React.FC<{ userId: string }> = ({ userId }) => {
  const [passVisibility, setPassVisibility] = useState({
    newPassword: false,
    confirmPassword: false
  });
  const [errStates, setErrStates] = useState({
    newPassword: "",
    confirmPassword: ""
  });
  const [passwordStates, setPasswordStates] = useState({
    newPassword: "",
    confirmPassword: ""
  });

  // password states
  const validatePasswordStates = (): boolean => {
    const errors: typeof errStates = {
      newPassword: !passwordStates?.newPassword ? "Password is required." : !validatePassword(passwordStates?.newPassword) ? errMsg?.invalidPassword : "",
      confirmPassword: !passwordStates.confirmPassword ? "Confirm Password is required." : (passwordStates.newPassword !== passwordStates.confirmPassword) ? "Password and Confirm password must match." : "",
    };
    setErrStates(errors);
    // Check if there are any errors
    return !Object.values(errors).some(error => error !== "");
  };
  const [passLoader, setPassLoader] = useState<boolean>(false);
  const handlePasswordSubmit = async () => {
    if (validatePasswordStates()) {
      setPassLoader(true);
      const { res, err } = await httpRequest<{ message: string }>({
        method: "put",
        path: `/customer/admin/${userId}/change-password`,
        params: passwordStates
      });
      if (res) {
        setPasswordStates({
          newPassword: "",
          confirmPassword: "",
        });
        setPassVisibility({
          newPassword: false,
          confirmPassword: false,
        });
        setErrStates({
          newPassword: "",
          confirmPassword: "",
        });
        toast(res?.message || "Success!", { type: "success" });
      } else {
        toast(err, { type: "error" });
      }
      setPassLoader(false);
    }
  };
  // password states

  // email states
  const [emailLoader, setEmailLoader] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");
  const [newEmail, setNewEmail] = useState<string>("");
  const validateEmailForm = (): boolean => {
    if (!newEmail) {
      setEmailError("Email is required.")
      return false;
    } else if (!validateEmail(newEmail)) {
      setEmailError(errMsg?.invalidEmail)
      return false;
    }
    return true;
  };
  const handleEmailSubmit = async () => {
    if (validateEmailForm()) {
      setEmailLoader(true);
      const { res, err } = await httpRequest<{ message: string }>({
        method: "put",
        path: `/customer/admin/${userId}/change-email`,
        params: { newEmail }
      });
      if (res) {
        setNewEmail("");
        setEmailError("");
        toast(res?.message || "Success!", { type: "success" });
      } else {
        toast(err, { type: "error" });
      }
      setEmailLoader(false);
    }
  };
  // email states

  return (
    <div className="products-tabs-content-main">
      {/* <div className='products-tabs-content'>
        <h2 className='title-heading font-Poppins-SemiBold font-size-20px pb-3'>Change Password</h2>
        <div className='emirates-id-main-margin'>
          <SimpleInput
            isLabel={true}
            labelText="Password"
            value={passwordStates?.newPassword}
            onChange={(val: string) => setPasswordStates(prev => ({ ...prev, newPassword: val }))}
            showPasswordEye={true}
            type={passVisibility["newPassword"] ? "text" : "password"}
            tooglePasswordVisibility={() => setPassVisibility(prev => ({ ...prev, newPassword: !prev.newPassword }))}
          />
          {errStates?.newPassword &&
            <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">{errStates?.newPassword}</p>
          }
        </div>
        <div className='emirates-id-main-margin'>
          <SimpleInput
            isLabel={true}
            labelText="Confirm Password"
            value={passwordStates?.confirmPassword}
            onChange={(val: string) => setPasswordStates(prev => ({ ...prev, confirmPassword: val }))}
            showPasswordEye={true}
            type={passVisibility["confirmPassword"] ? "text" : "password"}
            tooglePasswordVisibility={() => setPassVisibility(prev => ({ ...prev, confirmPassword: !prev.confirmPassword }))}
          />
          {errStates?.confirmPassword &&
            <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">{errStates?.confirmPassword}</p>
          }
        </div>
      </div> */}
      {/* <div className='flex justify-end my-6'>
        <PrimaryBtn
          loader={passLoader}
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={handlePasswordSubmit}
        />
      </div> */}

      <div className='products-tabs-content'>
        <h2 className='title-heading font-Poppins-SemiBold font-size-20px pb-3'>Change Email</h2>
        <div className='emirates-id-main-margin'>
          <SimpleInput
            isLabel={true}
            labelText="New Email"
            value={newEmail}
            onChange={(val: string) => setNewEmail(val)}
          />
          {emailError &&
            <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">{emailError}</p>
          }
        </div>
      </div>
      <div className='flex justify-end my-6'>
        <PrimaryBtn
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={handleEmailSubmit}
          loader={emailLoader}
        />
      </div>
    </div>
  );
};

export default UserAccountDetails;